import { styled } from "../../../../styled-components";

export const CircleProgressStyle = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .circle-progress-container {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 ${p => p.theme.pageMarginMedium}px ${p => p.theme.pageMarginMedium}px;
        position: relative;
        width: 100%;
    }

    & svg:nth-child(1) {
        height: 240px;
        width: 240px;
    }

    &.half-circle svg:nth-child(1) {
        height: 132px;
        width: 240px;
    }
`;

export const CircleProgressCenter = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    z-index: 5;

    animation: fadein 0.5s;

    @keyframes fadein {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    .total-value {
        width: 124px;
        height: 40px;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: bold;
        color: ${p => p.theme.fgColorDark};
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

export const HalfCircleProgressCenter = styled(CircleProgressCenter)`
    padding-top: 50px;
`;
